var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQrCodeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-qr-code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162651",
    "data-name": "Group 162651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    d: "M5.611,0H0V5.611H5.611ZM4.489,4.489H1.122V1.122H4.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147703",
    "data-name": "Rectangle 147703",
    width: 1,
    height: 1,
    transform: "translate(2 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4672",
    "data-name": "Path 4672",
    d: "M352,0V5.611h5.611V0Zm4.489,4.489h-3.367V1.122h3.367Z",
    transform: "translate(-339.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147704",
    "data-name": "Rectangle 147704",
    width: 1,
    height: 1,
    transform: "translate(15 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4673",
    "data-name": "Path 4673",
    d: "M0,357.611H5.611V352H0Zm1.122-4.489H4.489v3.367H1.122Z",
    transform: "translate(0 -339.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147705",
    "data-name": "Rectangle 147705",
    width: 1,
    height: 1,
    transform: "translate(2 15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147706",
    "data-name": "Rectangle 147706",
    width: 2,
    height: 1,
    transform: "translate(9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    d: "M194.244,35.367h1.122V34.244h1.122V33.122h-3.367V32H192v2.244h2.244Z",
    transform: "translate(-185.267 -30.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147707",
    "data-name": "Rectangle 147707",
    width: 1,
    transform: "translate(7 5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4675",
    "data-name": "Path 4675",
    d: "M196.489,160h-1.122v1.122H192v1.122h4.489Z",
    transform: "translate(-185.267 -154.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4676",
    "data-name": "Path 4676",
    d: "M1.122,195.367H2.244v-1.122H1.122V192H0v4.489H1.122Z",
    transform: "translate(0 -185.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147708",
    "data-name": "Rectangle 147708",
    width: 1,
    height: 1,
    transform: "translate(2 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    d: "M99.367,196.489h2.244v-1.122h-1.122v-1.122H98.244V192H97.122v2.244H96v2.244h1.122v-1.122h2.244Z",
    transform: "translate(-92.633 -185.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147709",
    "data-name": "Rectangle 147709",
    width: 1,
    height: 2,
    transform: "translate(10 9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    d: "M195.367,352H192v1.122h2.244v3.367H192v1.122h3.367v-1.122h2.244v-1.122h-2.244Z",
    transform: "translate(-185.267 -339.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147710",
    "data-name": "Rectangle 147710",
    width: 1,
    height: 1,
    transform: "translate(7 15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147711",
    "data-name": "Rectangle 147711",
    width: 1,
    height: 3,
    transform: "translate(11 12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4679",
    "data-name": "Path 4679",
    d: "M387.367,416H384v3.367h1.122v-2.244h2.244Z",
    transform: "translate(-370.533 -401.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147712",
    "data-name": "Rectangle 147712",
    width: 2,
    transform: "translate(16 18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147713",
    "data-name": "Rectangle 147713",
    height: 1,
    transform: "translate(18 12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4680",
    "data-name": "Path 4680",
    d: "M353.122,291.367h1.122V288H352v1.122h1.122Z",
    transform: "translate(-339.656 -277.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4681",
    "data-name": "Path 4681",
    d: "M355.367,193.122h-1.122V192h-1.122v1.122H352v1.122h4.489v-1.122h1.122V192h-2.244Z",
    transform: "translate(-339.656 -185.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147714",
    "data-name": "Rectangle 147714",
    width: 2,
    height: 1,
    transform: "translate(16 10)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQrCodeWhite);
export default __webpack_public_path__ + "static/media/ic-qr-code-white.11253b6aa180354211cc928498316348.svg";
export { ForwardRef as ReactComponent };